import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

import { AppHttpError } from '../models/app-http-error.model';

const CORRELATION_ID_HEADER = 'X-Correlation-Id';

interface BackendErrorBody {
  error?: {
    code?: string;
    message?: string;
    correlation_id?: string;
    details?: unknown;
  };
}

function normalizeError(
  req: { headers: { get(name: string): string | null } },
  error: HttpErrorResponse,
): AppHttpError {
  const envelope = (error.error as BackendErrorBody | null)?.error ?? {};

  return {
    status: error.status,
    code: envelope.code,
    message: envelope.message ?? error.message ?? 'An unexpected error occurred.',
    correlationId: envelope.correlation_id ?? req.headers.get(CORRELATION_ID_HEADER) ?? undefined,
    details: envelope.details,
    timestamp: new Date().toISOString(),
    originalError: error,
  };
}

// Centralized HTTP error handling: normalizes errors into a typed AppHttpError for callers to react to.
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse)) {
        return throwError(() => error);
      }

      const appError = normalizeError(req, error);

      return throwError(() => appError);
    }),
  );
};
